import type { CityConfig } from "../city-template/types";

export const knoxvilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Knoxville",
  state: "Tennessee",
  stateAbbr: "TN",
  slug: "knoxville",
  route: "/cities/knoxville",
  title: "Emergency Passport Knoxville, TN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Knoxville, Tennessee — as fast as 24 hours. Fast passport renewal and new passport applications for Knoxville, Maryville, Oak Ridge, Sevierville, and all East Tennessee residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Knoxville, TN",
  heroSubtitle: "Knoxville travelers — from University of Tennessee faculty to Oak Ridge National Laboratory professionals to Great Smoky Mountains visitors — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Knoxville%20Tennessee%20skyline%20with%20the%20Tennessee%20River%20winding%20through%20downtown%2C%20iconic%20Sunsphere%20tower%20visible%2C%20modern%20buildings%20mixed%20with%20historic%20architecture%2C%20University%20of%20Tennessee%20campus%20in%20the%20background%2C%20lush%20green%20trees%20and%20rolling%20hills%2C%20warm%20golden%20afternoon%20sunlight%2C%20vibrant%20East%20Tennessee%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=knoxville-hero-001&orientation=landscape",
  heroImageAlt: "Knoxville Tennessee skyline with Tennessee River and Sunsphere tower",
  geoPosition: "35.9606;-83.9207",
  geoPlacename: "Knoxville, Tennessee",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 180 miles south of Knoxville — about 2.5 hours via I-75",
  },
  nearbyCitiesZips: [
    { name: "Knoxville", zips: "37901, 37902, 37909, 37912, 37914, 37915, 37916, 37917, 37918, 37919, 37920, 37921, 37922, 37923, 37924, 37927, 37928, 37929, 37930, 37931, 37932, 37933, 37934, 37938, 37939, 37940, 37950, 37995, 37996, 37997, 37998" },
    { name: "Maryville", zips: "37801, 37802, 37803, 37804" },
    { name: "Oak Ridge", zips: "37830, 37831" },
    { name: "Sevierville", zips: "37862, 37863, 37864" },
    { name: "Gatlinburg", zips: "37738" },
    { name: "Pigeon Forge", zips: "37863, 37868" },
    { name: "Farragut", zips: "37922, 37934" },
    { name: "Powell", zips: "37849" },
    { name: "Halls", zips: "37918, 37924" },
    { name: "Alcoa", zips: "37701" },
    { name: "Clinton", zips: "37716, 37717" },
    { name: "Lenoir City", zips: "37771, 37772" },
    { name: "Louisville", zips: "37777" },
    { name: "Blount County", zips: "37801, 37803, 37804, 37701" },
    { name: "Anderson County", zips: "37830, 37705, 37716" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Atlanta Passport Agency — no 2.5-hour drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "University & Lab Hub", desc: "Serving UT Knoxville, Oak Ridge National Lab, and Smoky Mountains tourism" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no road trip to Nashville" },
  ],
  internalLinks: [
    { name: "Expedited passport in Nashville, TN", route: "/nashville" },
    { name: "Emergency passport help in Memphis, TN", route: "/memphis" },
    { name: "Urgent passport services in Chattanooga, TN", route: "/chattanooga" },
    { name: "Tennessee passport services overview", route: "/tennessee" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Knoxville, Tennessee remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency (2.5 hours west via I-40) — Knoxville's closest regional agency. Knoxville residents can ship from any UPS or FedEx in Knox County.",
  fpcOfficeAddress: "1221 Broadway Suite 1400, Nashville, TN 37203",
  fpcOfficeDistance: "Serving Knoxville, Maryville, Oak Ridge, Sevierville, Gatlinburg, Pigeon Forge, Farragut, Powell, Alcoa, Clinton, Lenoir City, and all of East Tennessee and the Great Smoky Mountains region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Knoxville and East Tennessee. From downtown Knoxville near the University of Tennessee campus to the suburban communities of Farragut and Powell — from the Great Smoky Mountains gateway towns of Sevierville, Gatlinburg, and Pigeon Forge to Oak Ridge and Maryville — we serve all of East Tennessee.",
  nearbyCitiesIntro: "We serve Knoxville and all nearby communities including Maryville, Oak Ridge, Sevierville, Gatlinburg, Pigeon Forge, Farragut, Powell, Halls, Alcoa, Clinton, Lenoir City, and Louisville. We also serve all of Knox County, Blount County, Sevier County, and Anderson County.",
  howItWorksIntro: "Most Knoxville travelers complete everything online and ship documents overnight. No need to drive 2.5 hours to Nashville — our couriers handle the agency hand-delivery and always pick the fastest route.",
  mistakesIntro: "Knoxville is a major university and research hub with significant international travel from UT Knoxville and Oak Ridge National Laboratory. Here are the most common passport mistakes we see from East Tennessee travelers.",
  testimonialsIntro: "Knoxville travelers — from UT faculty to Oak Ridge researchers to Smoky Mountains families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Knoxville, TN? Here are the most common ones we hear from East Tennessee travelers.",
  servicesIntro: "Whether you need a renewal before a TYS connection to Europe, an emergency passport for a last-minute Oak Ridge research trip, or a first-time passport for a Smoky Mountains family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  statePageRoute: "/states/tennessee",
  statePageName: "Tennessee",
  dmvWebsite: "https://www.tn.gov/safety/driver-services.html",
  dmvLabel: "Tennessee Driver Services — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Atlanta Passport Agency — fastest route", "No long drive required", "Perfect for university and research travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Atlanta Passport Agency access", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 2.5 hours to Nashville", "Full day commitment — difficult from Knoxville"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Knoxville travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Atlanta Passport Agency. Perfect for last-minute research conferences, university travel, and Smoky Mountains tourism.",
      bullets: ["24–48 hour turnaround available", "Atlanta Passport Agency via courier", "East Tennessee and Smoky Mountains support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Knoxville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your East Tennessee address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Knoxville residents and families — including UT students, new citizens, and East Tennessee families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Knoxville residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Knoxville and East Tennessee families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Knoxville and East Tennessee residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second valid passport for frequent research conferences or university travel? Knoxville academics and professionals often require a second passport while one is held for visa processing.",
      bullets: ["Ideal for frequent international travelers", "Use while primary passport is in visa processing", "Full 10-year validity"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Water-damaged, torn, or unreadable passports are not valid for travel. We replace damaged passports quickly for Knoxville and East Tennessee residents.",
      bullets: ["DS-11 replacement for damaged books", "Document condition review", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size passport card for land and sea border crossings to Mexico, Canada, and the Caribbean. Popular for Knoxville travelers taking Caribbean cruises from nearby ports.",
      bullets: ["Valid for land and sea travel only", "Fits in your wallet — convenient carry", "Less expensive than a passport book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Knoxville TN", description: "Urgent passport processing for Knoxville Tennessee travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Knoxville TN", description: "Fast passport renewal for Knoxville Tennessee residents with a previously-issued passport." },
    { name: "First-Time Passport Knoxville TN", description: "New passport application services for Knoxville Tennessee residents applying for their first passport." },
    { name: "Child Passport Knoxville TN", description: "Minor passport services for Knoxville Tennessee families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Emily R.",
      location: "Knoxville, TN",
      rating: 5,
      text: "Research conference in Geneva in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Kingston Pike and the whole process was seamless. Outstanding service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Maryville, TN",
      rating: 5,
      text: "Family trip to the Caribbean with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on Alcoa Highway and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jessica W.",
      location: "Oak Ridge, TN",
      rating: 5,
      text: "International collaboration meeting in Tokyo with 7 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for East Tennessee.",
      service: "Emergency Passport",
    },
    {
      name: "Tom H.",
      location: "Sevierville, TN",
      rating: 5,
      text: "Lost my passport the week before a honeymoon cruise to the Bahamas. Fast Passport Center replaced it in 48 hours. No way I could have driven to Nashville and back while running my business.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "knox-1",
      name: "Knoxville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 E Jackson Ave",
      city: "Knoxville",
      state: "TN",
      zip: "37915",
      phone: "(865) 544-6604",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Knoxville, near the Old City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Knoxville acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and UT campus.",
      icon: "ri-mail-line",
    },
    {
      id: "knox-2",
      name: "West Knoxville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6730 Central Avenue Pike",
      city: "Knoxville",
      state: "TN",
      zip: "37912",
      phone: "(865) 688-8081",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Knoxville, approximately 6 miles west of downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Farragut, West Knoxville, and western Knox County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "knox-3",
      name: "Maryville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "311 Greenbelt Dr",
      city: "Maryville",
      state: "TN",
      zip: "37801",
      phone: "(865) 983-2104",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Maryville, approximately 20 miles south of downtown Knoxville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Maryville, Alcoa, and Blount County. Good alternative for south-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "knox-4",
      name: "Sevierville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 E Main St",
      city: "Sevierville",
      state: "TN",
      zip: "37862",
      phone: "(865) 453-5521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sevierville, approximately 30 miles east of downtown Knoxville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Sevierville, Gatlinburg, Pigeon Forge, and Sevier County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "knox-5",
      name: "Knox County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "400 Main St Suite 105",
      city: "Knoxville",
      state: "TN",
      zip: "37902",
      phone: "(865) 215-2385",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Knoxville, near the courthouse",
      website: "https://knoxcounty.org/clerk/",
      websiteLabel: "Knox County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 2.5 hour drive to Atlanta", fpc: "No — ship from Knoxville" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Best Price Guarantee", agency: "No — government fees only", fpc: "Yes — 30-100% less than resellers" },
    { feature: "Local Expertise", agency: "Generic — no local knowledge", fpc: "Yes — East TN research & university guidance" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Knoxville university professionals and researchers often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Kingston Pike or Alcoa Highway sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Knox County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Knoxville Post Office appointments fill during summer and fall semester travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Drive to Nashville",
      description: "Many Knoxville residents attempt to drive to Nashville for an emergency appointment. The 2.5-hour drive each way through the mountains means a full day lost — our courier service is faster and more reliable.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Knoxville area or East Tennessee." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Kingston Pike or downtown Knoxville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Atlanta Passport Agency — the closest regional agency to Knoxville." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Knoxville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Knoxville, TN?", a: "Fast Passport Center offers emergency passport processing in Knoxville, Tennessee in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency (2.5 hours west via I-40) — without you making the drive." },
    { q: "Does Knoxville have a passport agency?", a: "No — Knoxville does not have a regional passport agency. The nearest facility is the Atlanta Passport Agency (approximately 2.5 hours west via I-40). Fast Passport Center's courier service means Knoxville residents never need to make that drive." },
    { q: "Can I get an expedited passport in Maryville, Oak Ridge, or Sevierville?", a: "Absolutely. Fast Passport Center serves all of East Tennessee including Maryville, Oak Ridge, Sevierville, Gatlinburg, Pigeon Forge, Farragut, Powell, Alcoa, Clinton, Lenoir City, and all of Knox, Blount, Sevier, and Anderson counties. Our service works the same way everywhere." },
    { q: "What airport do Knoxville travelers use for international flights?", a: "McGhee Tyson Airport (TYS) is the primary airport for Knoxville and East Tennessee. TYS offers limited international service. Most international travelers connect through Atlanta (ATL), Charlotte (CLT), or Nashville (BNA). Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Atlanta passport agency from Knoxville?", a: "Yes, but the Atlanta Passport Agency is approximately 4 hours south of Knoxville via I-75. The Atlanta Passport Agency is closer at 2.5 hours west via I-40. Fast Passport Center's couriers serve the Nashville agency — we always choose the fastest option for your timeline." },
    { q: "How much does an expedited passport cost in Knoxville, TN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Knoxville?", a: "Walgreens, CVS, and UPS Store locations throughout Knoxville, Maryville, and Sevierville offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve University of Tennessee students?", a: "Yes. Fast Passport Center serves all of East Tennessee including University of Tennessee students, faculty, and staff. We understand academic conference schedules and study abroad deadlines. Our courier service is especially valuable for students who can't take a day off to drive to Nashville." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Knoxville Residents",
    intro: "Knoxville's position as East Tennessee's research and university powerhouse — combined with its proximity to the Great Smoky Mountains National Park — creates a distinctive passport landscape. Here's what Knoxville travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "TYS — McGhee Tyson Airport",
        subtitle: "Knoxville's primary airport, limited international service",
        description: "McGhee Tyson Airport (TYS) serves Knoxville and East Tennessee with daily flights to major domestic hubs including Atlanta, Charlotte, Dallas, and Chicago. International flights from TYS itself are limited — Allegiant offers seasonal service to a few destinations. Most Knoxville international travelers connect through ATL (Delta's massive hub), CLT (American hub), or BNA. The connecting-flight reality means passport validity is verified at TYS check-in, not at the international gateway — an expired passport gets you stopped before you leave Knoxville.",
        tip: "Connecting through ATL or CLT does not exempt you from passport checks at TYS. Airlines verify passport validity for the entire international itinerary at the first check-in point. Check your passport before heading to the airport.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ATL — Atlanta Hartsfield-Jackson",
        subtitle: "World's busiest airport, 3.5 hours south via I-75",
        description: "Many East Tennessee travelers drive to Atlanta for international flights rather than connecting through TYS. ATL offers nonstop service to 200+ international destinations — nearly every country in the world. The 3.5-hour drive from Knoxville is feasible for a planned trip, especially for families seeking direct flights to Europe, Asia, or South America. However, Atlanta is also the location of one of the busiest passport agencies in the country — leading some Knoxville travelers to mistakenly believe they can combine a passport agency visit with their ATL departure.",
        tip: "The Atlanta Passport Agency serves life-or-death emergencies by appointment only. It is not a walk-in service and does not process passports same-day for convenience. Do not plan to 'pick up' a passport at the Atlanta agency on the way to your ATL flight.",
      },
      {
        icon: "ri-flask-line",
        title: "Oak Ridge National Laboratory Travel",
        subtitle: "DOE research facility, international scientific collaboration",
        description: "Oak Ridge National Laboratory (ORNL) is the largest U.S. Department of Energy science and energy laboratory, employing over 5,700 scientists and engineers. ORNL researchers routinely travel to international facilities including CERN (Switzerland), ITER (France), and partner labs in Japan, Germany, and the UK. Scientific collaboration travel is often confirmed on short notice — 1–3 weeks — when experiment schedules align or when a collaborator's facility becomes available. ORNL researchers also attend international conferences in their fields on 2–4 week notice.",
        tip: "ORNL researchers traveling to DOE facilities abroad should verify whether they need an official (maroon) passport in addition to their tourist (blue) passport. Some DOE assignments require official passports processed through a different channel.",
      },
      {
        icon: "ri-landscape-line",
        title: "Great Smoky Mountains Tourism",
        subtitle: "Most-visited national park, international visitors, seasonal family travel",
        description: "The Great Smoky Mountains National Park attracts over 12 million visitors annually — the most of any U.S. national park. This tourism ecosystem creates two distinct passport patterns. First: international visitors to the Smokies (especially from Europe and Asia) who extend their U.S. trip and discover passport issues while in East Tennessee. Second: East Tennessee families and tourism business owners who travel internationally during the off-season (November–March) — Gatlinburg hotel owners visiting European trade shows, Sevierville attraction operators attending tourism conferences in London and Tokyo.",
        tip: "Smoky Mountains tourism professionals attending international trade shows (ITB Berlin, World Travel Market London) often book 6–12 months ahead. Check passport validity at the time of conference registration, not the month before departure.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Knoxville & the Dual-Agency Dilemma",
      description: "Knoxville is uniquely positioned roughly equidistant (within 30 minutes) between two passport agencies: Nashville (2.5 hours west) and Atlanta (3.5 hours south). While neither is close, this creates a false sense of flexibility. Our courier service eliminates the drive entirely — processing through the Atlanta Passport Agency with overnight courier routing that is faster than any self-drive option from East Tennessee.",
    },
  },
  destinations: {
    title: "Where Knoxville Travelers Go — And Why Passports Get Urgent",
    intro: "East Tennessee's research, academic, and tourism ecosystem sends travelers to destinations spanning science, education, and leisure. Here are the most common international destinations and urgency patterns.",
    stats: [
      { stat: "35%", label: "of Knoxville expedited requests are university/research travel with under 3 weeks notice" },
      { stat: "2–4 Weeks", label: "average lead time Knoxville travelers have from trip booking to international departure" },
      { stat: "Mar–May", label: "peak season when spring break, academic conferences, and summer research planning collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for an ORNL researcher departing to Geneva" },
    ],
    destinations: [
      { name: "Switzerland & France", context: "ORNL-CERN collaboration in Geneva, ITER facility in Cadarache, UT study abroad programs, scientific conferences", urgency: "Research collaboration travel booked 1–3 weeks out when experiment schedules align", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "ORNL partner lab visits to Karlsruhe and Jülich, UT Knoxville engineering exchanges, Volkswagen supplier meetings", urgency: "Academic exchange programs with 4–8 week acceptance-to-departure windows", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "ORNL-DENKA collaboration, UT materials science partnerships, Nissan/automotive supplier travel", urgency: "Japan requires 6-month passport validity; business trips booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "ORNL-UKAEA fusion energy collaboration, UT study abroad programs, Smoky Mountains tourism trade shows", urgency: "Conference travel booked 2–4 weeks ahead with fixed presentation dates", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Spring break from UT, family resort vacations, destination weddings in Cancun and Riviera Maya", urgency: "Spring break bookings peak January through March; wedding bookings 3–6 months out", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "UT Knoxville academic partnerships, Toronto and Vancouver research collaborations, Smoky Mountains tourism cross-promotion", urgency: "Cross-border academic travel often confirmed 2–3 weeks before event", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Tennessee Service Areas",
    crossLinksDesc: "We serve travelers across the Volunteer State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Nashville", route: "/nashville" },
      { name: "Memphis", route: "/memphis" },
      { name: "Chattanooga", route: "/chattanooga" },
    ],
  },
  photoLocations: [
    { name: "Walgreens — Kingston Pike", address: "4435 Kingston Pike, Knoxville, TN 37919", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — West Knoxville", address: "6730 Central Avenue Pike, Knoxville, TN 37912", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Maryville", address: "2625 US-411, Maryville, TN 37801", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "CVS — Sevierville", address: "220 Forks of the River Pkwy, Sevierville, TN 37862", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "Tennessee DOS — Knoxville", address: "7320 Region Ln, Knoxville, TN 37914", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Tennessee Department of Safety for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "Tennessee DOS — Maryville", address: "1610 E Lamar Alexander Pkwy, Maryville, TN 37804", hours: "Tue–Sat: 8:30AM–5:00PM", note: "Serves Maryville, Alcoa, and Blount County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "TYS",
      name: "McGhee Tyson Airport",
      distance: "12 miles south of downtown Knoxville via Alcoa Highway",
      address: "2055 Alcoa Hwy, Alcoa, TN 37701",
      note: "Primary airport for Knoxville and East Tennessee. Limited international passenger service. Most international travel connects through Atlanta (ATL), Charlotte (CLT), or Nashville (BNA).",
      flightUrl: "https://www.tys.org/",
      flightLabel: "TYS Flight Info",
      featured: true,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "Approximately 2.5 hours west of Knoxville via I-40",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Alternative airport for Knoxville travelers seeking more international routes. Direct flights to London, Toronto, and Cancun. British Airways offers nonstop to London Heathrow.",
      flightUrl: "https://www.flynashville.com/",
      flightLabel: "BNA Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Tennessee Department of Health Vital Records office. Online, mail, or in-person options available for Knox County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/birth-certificates.html",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Tennessee Vital Records. Required for estate and legal matters in Knox County.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/death-records.html",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Knox County Clerk. Certified copies available for name changes and passport applications.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/marriage.html",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Knox County Circuit Court Clerk. Required for name change passport corrections.",
      url: "https://www.tn.gov/health/health-program-areas/vital-records/divorce.html",
    },
  ],
};